import { useState, useEffect, useRef } from "react";

// Hook
export const useWindowSize = () => {
  //Object represents browser window
  const isClient = typeof window === "object";
  const lastWidth = useRef();
  const lastHeight = useRef();
  function getSize() {
    lastWidth.current = window.innerWidth;
    lastHeight.current = window.innerHeight;
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined,
    };
  }

  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    //Exit if not user/browser
    if (!isClient) {
      return false;
    }

    function handleResize() {
      if (
        window?.innerWidth !== lastWidth.current ||
        window?.innerHeight !== lastHeight.current
      ) {
        console.log("useWindowSize CHANGED");
        setWindowSize(getSize());
      } else {
        console.log("useWindowSize has not changed");
      }
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return windowSize;
};
